export class MaterialMatcher {
  /**
   * If not empty, the work item main product must
   * be one of the given material ids.
   */
  public allowedMaterialIds: string[] = []

  /**
   * If not empty, the work item main product must
   * be one of the given material groups.
   */
  public allowedMaterialGroups: string[] = []

  /**
   * If not empty, the work item main product must
   * be one of the given material types.
   */
  public allowedMaterialTypes: string[] = []

  /**
   * If not empty, the work item main product must
   * be one of the given material hierarchies.
   */
  public allowedMaterialHierarchies: string[] = []
}
